export class DirectoryBrowserAddEntry {
   public static readonly type = '[Directory Editing] Add Entry';

   constructor(public brickInstanceId: string) {}
}

export class DirectoryBrowserEditEntry {
   public static readonly type = '[Directory Editing] Edit Entry';

   constructor(public brickInstanceId: string) {}
}

export class DirectoryBrowserCreateEditEntry {
   public static readonly type = '[Directory Editing] Create Edit Entry';

   constructor(public brickInstanceId: string) {}
}

export class DirectoryBrowserRemoveEditEntry {
   public static readonly type = '[Directory Editing] Remove Edit Entry';

   constructor(public id: number) {}
}

export class DirectoryBrowserUpdateOriginEntry {
   public static readonly type = '[Directory Editing] Update Origin Entry';

   constructor(public id: number, public field: string, public value: string | number | boolean | Date) {}
}

export class DirectoryBrowserUpdateEditEntry {
   public static readonly type = '[Directory Editing] Update Edit Entry';

   constructor(public id: number, public field: string, public value: string | number | boolean | Date) {}
}

export class DirectoryBrowserAddEditedEntry {
   public static readonly type = '[Directory Editing] Add Edited Entry';

   constructor(public id: number) {}
}

export class DirectoryBrowserUpdateEditedEntry {
   public static readonly type = '[Directory Editing] Update Edited Entry';

   constructor(public id: number, public sourceBrickInstanceId: string = '') {}
}

export class DirectoryBrowserDeleteEditedEntry {
   public static readonly type = '[Directory Editing] Delete Edited Entry';

   constructor(public id: number, public sourceBrickInstanceId: string = '') {}
}

export class DirectoryBrowserEditedUpdateOriginEntry {
   public static readonly type = '[Directory Editing] Edited Update Origin Entry';

   constructor(public id: number) {}
}

export class DirectoryBrowserEditedSetConfirmationInProgress {
   public static readonly type = '[Directory Editing] Edited Set Confirmation In Progress';

   constructor(public id: number, public isConfirmationInProgress: boolean) {}
}

export class DirectoryBrowserEditedClearUpdatedEntry {
   public static readonly type = '[Directory Editing] Edited Clear Updated Entry';

   constructor(public id: number) {}
}
